import { Component, Input, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-rotating-text-header',
  templateUrl: './rotating-text-header.component.html',
  styleUrls: ['./rotating-text-header.component.scss'],
  standalone: false,
})
export class RotatingTextHeaderComponent implements OnInit, OnDestroy {
  @Input() staticText: string = 'What do you want to know about';
  @Input() subheaderText: string = 'Real-time intelligence on 200M+ professionals.'; // Ask anything or choose a starting point below.';
  @Input() rotatingOptions: string[] = [
    'the workforce',
    'your company',
    "who's hiring",
    'where to invest',
    'your competitors',
    'hiring trends',
    'recent layoffs',
  ];
  @Input() rotationIntervalMs: number = 3000;

  currentText: string = '';
  private currentIndex: number = 0;
  private intervalId?: number;
  isAnimating: boolean = false;

  ngOnInit() {
    if (this.rotatingOptions.length > 0) {
      this.currentText = this.rotatingOptions[0];
      this.startRotation();
    }
  }

  ngOnDestroy() {
    this.stopRotation();
  }

  private startRotation() {
    this.intervalId = window.setInterval(() => {
      this.rotateText();
    }, this.rotationIntervalMs);
  }

  private stopRotation() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = undefined;
    }
  }

  private rotateText() {
    // Trigger fade out
    this.isAnimating = true;

    // Wait for fade out, then change text and fade in
    setTimeout(() => {
      this.currentIndex = (this.currentIndex + 1) % this.rotatingOptions.length;
      this.currentText = this.rotatingOptions[this.currentIndex];
      this.isAnimating = false;
    }, 300); // Half of the transition duration for smooth transition
  }
}
